import React from 'react';
import {
  ColumnInformation,
  joinClassNames,
  TableSorterField,
  TableSorterInformation,
} from '@utahdts/dts-react-common';
import Icon from '../../misc/Icon';
import RowActionsPopover from '../../misc/RowActionsPopover';
import TableSorterSortType from '@utahdts/dts-react-common/components/table-sorter/TableSorterSortType';
import TableSorterDirection from '@utahdts/dts-react-common/components/table-sorter/TableSorterDirection';
import { textTd } from '../../misc/Shared';

const sorters = {
  companyName: new TableSorterField(
    'companyName',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  description: new TableSorterField(
    'description',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  ndc: new TableSorterField(
    'ndc',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
};

const defaultSorters = (firstSorter) =>
  new TableSorterInformation([
    firstSorter,
    ...Object.values(sorters).filter((sorter) => sorter !== firstSorter),
  ]);

export default (editDrug, deleteDrug) => {
  const customTd = (columnInfo, data) => {
    return (
      <td key={joinClassNames(columnInfo.field, data.description)}>
        <RowActionsPopover>
          <ul className="actions">
            <li
              className="actions-item"
              onClick={() => editDrug(false, data, true)}
            >
              {Icon.iconPencil()} Edit Drug
            </li>
            <li className="actions-item" onClick={() => deleteDrug(data)}>
              {Icon.iconTrash()} Delete Drug
            </li>
          </ul>
        </RowActionsPopover>
      </td>
    );
  };

  return [
    new ColumnInformation({
      title: 'Company Name',
      field: 'companyName',
      tableSorterInformation: defaultSorters(sorters.companyName),
      tdCallback: textTd,
    }),
    new ColumnInformation({
      title: 'Description',
      field: 'description',
      tableSorterInformation: defaultSorters(sorters.description),
      tdCallback: textTd,
    }),
    new ColumnInformation({
      title: 'Actions',
      field: 'actions',
      tdCallback: (columnInfo, data) => customTd(columnInfo, data),
      filter: false,
    }),
  ];
};
